// 自己封装的 uni.request 工具类
// var request = require("./jsTools/request.js");
var wx = require('../components/jweixin-module/index.js');
import * as dd from 'dingtalk-jsapi';
// import {
// 	basePath
// } from '../api/index.js'

export default {
	//判断是否在微信中  
	isWechat: function() {
		var ua = window.navigator.userAgent.toLowerCase();
		var type = ''
		if (ua.match(/micromessenger/i) == 'micromessenger') {
			console.log('微信客户端')
			type = "isWechat"
		} else if (ua.indexOf('dingtalk')>0) {
			console.log('钉钉客户端')
			type = "isDingTalk"
		} else if (window.plus) {
			console.log('bu微信客户端')
			type = "isApp"
		} else {
			type = "isH5"
		}
		return type
	},
	//初始化sdk配置  
	initJssdk: function(callback, url) {
		var url = location.href.split('?')[0]
		uni.request({
			url: 'https://api.saas123.com/amc/api/open/wx/getSignature',
			data: {
				url: decodeURI(window.location.href.split('#')[0]),
				clean: false
			},
			success: (res) => {
				if (res && res.data.success) {
					//注入config权限配置
					wx.config({
						debug: false,
						appId: res.data.data.appId,
						timestamp: res.data.data.timestamp,
						nonceStr: res.data.data.nonceStr,
						signature: res.data.data.signature,
						jsApiList: [ //这里是需要用到的接口名称
							'scanQRCode' // 微信扫码[二维码]
						]
					});
				} else {
					uni.showModal({
						title: '提示',
						content: '初始化失败，请稍后重试',
						success: (res) => {
							if (res.confirm) {
								uni.request({
									url: 'https://api.saas123.com/amc/api/open/wx/getSignature',
									data: {
										url: decodeURI(window.location.href.split('#')[0]),
										clean: true
									},
									success: (res) => {
										// console.log(res,'res')
										//注入config权限配置
										wx.config({
											debug: false,
											appId: res.data.data.appId,
											timestamp: res.data.data.timestamp,
											nonceStr: res.data.data.nonceStr,
											signature: res.data.data.signature,
											jsApiList: [ //这里是需要用到的接口名称
												'scanQRCode' // 微信扫码[二维码]
											]
										});
									}
								});
							} else if (res.cancel) {
								console.log('用户点击取消');
							}
						}

					})
				}
			}
		});
	},
	scanQRCode: function(callback) {
		if (this.isWechat() == 'isWechat') {
			wx.ready(function() {
				wx.scanQRCode({
					needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
					scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
					success: function(res) {
						callback(res)
					}
				});
			})
		} else if (this.isWechat() == 'isDingTalk') {
			dd.ready(function(){
				dd.biz.util.scan({
					type: 'all', // type 为 all、qrCode、barCode，默认是all
					onSuccess: function(data) {
						callback(data)
						//对返回的数据进行转换
					},
					onFail: function(err) {
						console.log(err)
					}
				});
			});
			
		} else {
			return
		}
	}
}
